import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useTheme as useAppTheme } from '../context/ThemeContext';
import clinicaService from '../services/clinicaService';
import usuarioService from '../services/usuarioService';
import api from '../services/api';
import ConexaoClaude from '../components/ConexaoClaude';
import {
  Box, Paper, Typography, TextField, Button, Avatar,
  Divider, Grid, Alert, Chip, Tab, Tabs, IconButton,
  InputAdornment, CircularProgress
} from '@mui/material';
import {
  Person as PersonIcon,
  LocalHospital as ClinicaIcon,
  Lock as LockIcon,
  Edit as EditIcon,
  Save as SaveIcon,
  Close as CloseIcon,
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
  Badge as BadgeIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  Business as BusinessIcon,
  MedicalServices as CroIcon,
  CheckCircle as CheckIcon,
  AddLink as ConectarIcon,
} from '@mui/icons-material';

function TabPanel({ children, value, index }) {
  return value === index ? <Box sx={{ pt: 3 }}>{children}</Box> : null;
}

function PerfilDentistaPage() {
  const { user, setUser } = useAuth();
  const { isDarkMode } = useAppTheme();
  const [clinica, setClinica] = useState(null);
  const [tab, setTab] = useState(0);
  const [editando, setEditando] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  // Dados pessoais
  const [nome, setNome] = useState(user?.nome || '');
  const [cro, setCro] = useState(user?.cro || '');
  const [telefone, setTelefone] = useState(user?.telefone || '');
  const [profissao, setProfissao] = useState(user?.profissao || '');

  // Dados clínica
  const [clinicaNome, setClinicaNome] = useState('');
  const [clinicaEmail, setClinicaEmail] = useState('');
  const [clinicaTelefone, setClinicaTelefone] = useState('');
  const [clinicaCnpj, setClinicaCnpj] = useState('');
  const [clinicaTipoPessoa, setClinicaTipoPessoa] = useState('');
  const [clinicaCep, setClinicaCep] = useState('');
  const [clinicaEndereco, setClinicaEndereco] = useState('');
  const [clinicaNumero, setClinicaNumero] = useState('');
  const [clinicaComplemento, setClinicaComplemento] = useState('');
  const [clinicaBairro, setClinicaBairro] = useState('');
  const [clinicaCidade, setClinicaCidade] = useState('');
  const [clinicaEstado, setClinicaEstado] = useState('');
  const [clinicaInscricaoMunicipal, setClinicaInscricaoMunicipal] = useState('');
  const [clinicaCodigoServico, setClinicaCodigoServico] = useState('');
  const [clinicaDescricaoPadraoNota, setClinicaDescricaoPadraoNota] = useState('');
  const [editandoClinica, setEditandoClinica] = useState(false);
  const [buscandoCep, setBuscandoCep] = useState(false);

  const buscarCep = async (cep) => {
    const soNumeros = cep.replace(/\D/g, '');
    if (soNumeros.length !== 8) return;
    setBuscandoCep(true);
    try {
      const res = await fetch(`https://viacep.com.br/ws/${soNumeros}/json/`);
      const data = await res.json();
      if (!data.erro) {
        setClinicaEndereco(data.logradouro || '');
        setClinicaBairro(data.bairro || '');
        setClinicaCidade(data.localidade || '');
        setClinicaEstado(data.uf || '');
      }
    } catch {}
    setBuscandoCep(false);
  };

  // Senha
  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [showSenha, setShowSenha] = useState(false);

  useEffect(() => {
    async function fetchClinica() {
      const clinicaId = user?.clinicaId;
      if (!clinicaId) return;
      try {
        const data = await clinicaService.buscarClinica(clinicaId);
        setClinica(data);
        setClinicaNome(data.nome || data.nome_fantasia || '');
        setClinicaEmail(data.email || '');
        setClinicaTelefone(data.telefone || data.whatsapp || '');
        setClinicaCnpj(data.cnpj || '');
        setClinicaTipoPessoa(data.tipoPessoa || data.tipo_pessoa || '');
        setClinicaCep(data.cep || '');
        setClinicaEndereco(data.endereco || '');
        setClinicaNumero(data.numero || '');
        setClinicaComplemento(data.complemento || '');
        setClinicaBairro(data.bairro || '');
        setClinicaCidade(data.cidade || '');
        setClinicaEstado(data.estado || '');
        setClinicaInscricaoMunicipal(data.inscricaoMunicipal || data.inscricao_municipal || '');
        setClinicaCodigoServico(data.codigoServico || data.codigo_servico || '');
        setClinicaDescricaoPadraoNota(data.descricaoPadraoNota || data.descricao_padrao_nota || '');
      } catch {
        setClinica(null);
      }
    }
    fetchClinica();
  }, [user?.clinicaId]);

  const planoAtual = user?.plano || user?.clinica?.plano || 'FREE';
  const tipoUsuario = user?.tipoPessoa || 'PF';
  const iniciais = nome ? nome.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase() : 'U';

  const fieldSx = {
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      background: isDarkMode ? undefined : '#FAFAFA',
      '&:hover fieldset': { borderColor: 'rgba(249,115,22,0.5)' },
      '&.Mui-focused fieldset': { borderColor: '#F97316' },
    },
    '& .MuiInputLabel-root.Mui-focused': { color: '#F97316' },
  };

  const handleSalvarPessoal = async () => {
    setLoading(true); setError('');
    try {
      await usuarioService.atualizar(user.id, { nome, cro, telefone, profissao });
      const atualizado = await api.get(`/usuarios/${user.id}`);
      if (atualizado?.nome) {
        setUser(atualizado);
        localStorage.setItem('user', JSON.stringify(atualizado));
      }
      setEditando(false);
      setSuccess('Dados pessoais atualizados!');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError('Erro ao salvar dados pessoais.');
    } finally { setLoading(false); }
  };

  const handleSalvarClinica = async () => {
    setLoading(true); setError('');
    try {
      await clinicaService.atualizarClinica(user.clinicaId, {
        nome: clinicaNome, email: clinicaEmail,
        telefone: clinicaTelefone, cnpj: clinicaCnpj,
        cep: clinicaCep, endereco: clinicaEndereco,
        numero: clinicaNumero, complemento: clinicaComplemento,
        bairro: clinicaBairro, cidade: clinicaCidade, estado: clinicaEstado,
        inscricaoMunicipal: clinicaInscricaoMunicipal,
        codigoServico: clinicaCodigoServico,
        descricaoPadraoNota: clinicaDescricaoPadraoNota,
      });
      setEditandoClinica(false);
      setSuccess('Dados da clínica atualizados!');
      setTimeout(() => setSuccess(''), 3000);
    } catch {
      setError('Erro ao salvar dados da clínica.');
    } finally { setLoading(false); }
  };

  const handleAlterarSenha = async () => {
    if (!novaSenha || novaSenha.length < 6) { setError('A nova senha deve ter pelo menos 6 caracteres.'); return; }
    if (novaSenha !== confirmarSenha) { setError('As senhas não conferem.'); return; }
    setLoading(true); setError('');
    try {
      await usuarioService.atualizar(user.id, { senha: novaSenha });
      setSenhaAtual(''); setNovaSenha(''); setConfirmarSenha('');
      setSuccess('Senha alterada com sucesso!');
      setTimeout(() => setSuccess(''), 3000);
    } catch {
      setError('Erro ao alterar senha.');
    } finally { setLoading(false); }
  };

  const cardSx = {
    p: 3, borderRadius: '12px',
    background: isDarkMode ? undefined : '#fff',
    border: '1px solid rgba(249,115,22,0.15)',
    borderTopWidth: '3px', borderTopColor: '#F97316',
    boxShadow: '0 2px 12px rgba(249,115,22,0.07)',
  };

  const infoBadge = (label, value, Icon) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.75 }}>
      <Icon sx={{ fontSize: '1rem', color: '#F97316', flexShrink: 0 }} />
      <Box>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1 }}>{label}</Typography>
        <Typography variant="body2" fontWeight={500}>{value || '—'}</Typography>
      </Box>
    </Box>
  );

  return (
    <Box sx={{ p: 3, backgroundColor: isDarkMode ? undefined : '#FFFAF5', minHeight: '100vh' }}>
      {/* Título */}
      <Typography variant="h4" fontWeight="bold" sx={{ borderLeft: '4px solid #F97316', pl: 1.5, mb: 3 }}>
        Meu Perfil
      </Typography>

      {success && <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess('')}>{success}</Alert>}
      {error   && <Alert severity="error"   sx={{ mb: 2 }} onClose={() => setError('')}>{error}</Alert>}

      <Grid container spacing={3}>

        {/* COLUNA ESQUERDA — Cartão identidade */}
        <Grid item xs={12} md={3}>
          <Paper elevation={0} sx={{ ...cardSx, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 1.5, py: 4 }}>
            <Avatar sx={{ width: 90, height: 90, fontSize: '2rem', fontWeight: 700, bgcolor: '#F97316', mb: 1 }}>
              {iniciais}
            </Avatar>
            <Typography variant="h6" fontWeight={700} sx={{ lineHeight: 1.2 }}>{nome || user?.nome}</Typography>
            <Typography variant="body2" color="text.secondary">{user?.email}</Typography>

            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'center', mt: 0.5 }}>
              <Chip label={planoAtual} size="small" sx={{ bgcolor: planoAtual === 'FREE' ? 'rgba(100,116,139,0.12)' : 'rgba(249,115,22,0.12)', color: planoAtual === 'FREE' ? '#64748b' : '#EA580C', fontWeight: 700, fontSize: '0.7rem' }} />
              <Chip label={tipoUsuario} size="small" sx={{ bgcolor: tipoUsuario === 'PJ' ? 'rgba(249,115,22,0.1)' : 'rgba(37,99,235,0.1)', color: tipoUsuario === 'PJ' ? '#EA580C' : '#2563EB', fontWeight: 700, fontSize: '0.7rem' }} />
            </Box>

            <Divider sx={{ width: '100%', my: 1, borderColor: 'rgba(249,115,22,0.12)' }} />

            <Box sx={{ width: '100%', textAlign: 'left', px: 1, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
              {infoBadge('CRO', cro || user?.cro, CroIcon)}
              {infoBadge('Telefone', telefone || user?.telefone, PhoneIcon)}
              {infoBadge('Clínica', clinicaNome, ClinicaIcon)}
              {infoBadge('CNPJ', clinicaCnpj, BusinessIcon)}
            </Box>
          </Paper>
        </Grid>

        {/* COLUNA DIREITA — Abas de edição */}
        <Grid item xs={12} md={9}>
          <Paper elevation={0} sx={cardSx}>
            <Tabs
              value={tab}
              onChange={(_, v) => setTab(v)}
              sx={{
                mb: 1,
                '& .MuiTabs-indicator': { backgroundColor: '#F97316' },
                '& .Mui-selected': { color: '#F97316 !important', fontWeight: 700 },
              }}
            >
              <Tab icon={<PersonIcon sx={{ fontSize: '1.1rem' }} />} iconPosition="start" label="Dados Pessoais" />
              <Tab icon={<ClinicaIcon sx={{ fontSize: '1.1rem' }} />} iconPosition="start" label="Clínica" />
              <Tab icon={<LockIcon sx={{ fontSize: '1.1rem' }} />} iconPosition="start" label="Segurança" />
              {user?.role === 'dentista' && (
                <Tab icon={<ConectarIcon sx={{ fontSize: '1.1rem' }} />} iconPosition="start" label="Conectar ao Claude" />
              )}
            </Tabs>

            <Divider sx={{ borderColor: 'rgba(249,115,22,0.12)' }} />

            {/* ABA DADOS PESSOAIS */}
            <TabPanel value={tab} index={0}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2.5 }}>
                <Typography variant="subtitle1" fontWeight={700} sx={{ color: '#F97316' }}>Informações Pessoais</Typography>
                {!editando
                  ? <Button startIcon={<EditIcon />} onClick={() => setEditando(true)} sx={{ borderColor: '#F97316', color: '#F97316', borderRadius: '8px' }} variant="outlined" size="small">Editar</Button>
                  : <Button startIcon={<CloseIcon />} onClick={() => setEditando(false)} size="small" sx={{ color: 'text.secondary' }}>Cancelar</Button>
                }
              </Box>
              <Grid container spacing={2.5}>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth size="small" label="Nome Completo" value={nome} onChange={e => setNome(e.target.value)} disabled={!editando} sx={fieldSx} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth size="small" label="E-mail" value={user?.email || ''} disabled sx={fieldSx} helperText="O e-mail não pode ser alterado" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth size="small" label="CRO / Registro Profissional" value={cro} onChange={e => setCro(e.target.value)} disabled={!editando} sx={fieldSx} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth size="small" label="Telefone" value={telefone} onChange={e => setTelefone(e.target.value)} disabled={!editando} sx={fieldSx} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth size="small" label="Profissão" value={profissao} onChange={e => setProfissao(e.target.value)} disabled={!editando} sx={fieldSx} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth size="small" label="Tipo de Pessoa" value={tipoUsuario} disabled sx={fieldSx} />
                </Grid>
              </Grid>
              {editando && (
                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                  <Button variant="contained" startIcon={<SaveIcon />} onClick={handleSalvarPessoal} disabled={loading}
                    sx={{ bgcolor: '#F97316', '&:hover': { bgcolor: '#EA580C' }, boxShadow: '0 2px 10px rgba(249,115,22,0.35)', borderRadius: '8px', fontWeight: 700 }}>
                    Salvar Dados
                  </Button>
                </Box>
              )}
            </TabPanel>

            {/* ABA CLÍNICA */}
            <TabPanel value={tab} index={1}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2.5 }}>
                <Typography variant="subtitle1" fontWeight={700} sx={{ color: '#F97316' }}>Dados da Clínica</Typography>
                {!editandoClinica
                  ? <Button startIcon={<EditIcon />} onClick={() => setEditandoClinica(true)} sx={{ borderColor: '#F97316', color: '#F97316', borderRadius: '8px' }} variant="outlined" size="small">Editar</Button>
                  : <Button startIcon={<CloseIcon />} onClick={() => setEditandoClinica(false)} size="small" sx={{ color: 'text.secondary' }}>Cancelar</Button>
                }
              </Box>
              {!clinica && !clinicaNome ? (
                <Box sx={{ p: 3, textAlign: 'center', borderRadius: '10px', bgcolor: 'rgba(249,115,22,0.05)', border: '1px dashed rgba(249,115,22,0.3)' }}>
                  <ClinicaIcon sx={{ fontSize: '2.5rem', color: 'rgba(249,115,22,0.4)', mb: 1 }} />
                  <Typography color="text.secondary">Carregando dados da clínica...</Typography>
                </Box>
              ) : (
                <Grid container spacing={2.5}>
                  <Grid item xs={12}>
                    <TextField fullWidth size="small" label="Nome Fantasia da Clínica" value={clinicaNome} onChange={e => setClinicaNome(e.target.value)} disabled={!editandoClinica} sx={fieldSx} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField fullWidth size="small" label="E-mail Comercial" value={clinicaEmail} onChange={e => setClinicaEmail(e.target.value)} disabled={!editandoClinica} sx={fieldSx} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField fullWidth size="small" label="WhatsApp / Telefone" value={clinicaTelefone} onChange={e => setClinicaTelefone(e.target.value)} disabled={!editandoClinica} sx={fieldSx} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField fullWidth size="small" label="CNPJ" value={clinicaCnpj} onChange={e => setClinicaCnpj(e.target.value)} disabled={!editandoClinica} sx={fieldSx} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField fullWidth size="small" label="Tipo de Pessoa" value={clinicaTipoPessoa} disabled sx={fieldSx} />
                  </Grid>

                  {/* Endereço */}
                  <Grid item xs={12}><Typography variant="caption" fontWeight={700} color="text.secondary">📍 Endereço</Typography></Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth size="small" label="CEP"
                      value={clinicaCep}
                      onChange={e => setClinicaCep(e.target.value)}
                      onBlur={e => buscarCep(e.target.value)}
                      disabled={!editandoClinica}
                      sx={fieldSx}
                      InputProps={{ endAdornment: buscandoCep ? <CircularProgress size={16} /> : null }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <TextField fullWidth size="small" label="Logradouro" value={clinicaEndereco} onChange={e => setClinicaEndereco(e.target.value)} disabled={!editandoClinica} sx={fieldSx} />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField fullWidth size="small" label="Número" value={clinicaNumero} onChange={e => setClinicaNumero(e.target.value)} disabled={!editandoClinica} sx={fieldSx} />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField fullWidth size="small" label="Complemento" value={clinicaComplemento} onChange={e => setClinicaComplemento(e.target.value)} disabled={!editandoClinica} sx={fieldSx} />
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <TextField fullWidth size="small" label="Bairro" value={clinicaBairro} onChange={e => setClinicaBairro(e.target.value)} disabled={!editandoClinica} sx={fieldSx} />
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <TextField fullWidth size="small" label="Cidade" value={clinicaCidade} onChange={e => setClinicaCidade(e.target.value)} disabled={!editandoClinica} sx={fieldSx} />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField fullWidth size="small" label="UF" value={clinicaEstado} onChange={e => setClinicaEstado(e.target.value)} disabled={!editandoClinica} sx={fieldSx} inputProps={{ maxLength: 2 }} />
                  </Grid>

                  {/* Dados Fiscais */}
                  <Grid item xs={12}><Typography variant="caption" fontWeight={700} color="text.secondary">🧾 Nota Fiscal</Typography></Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField fullWidth size="small" label="Inscrição Municipal" value={clinicaInscricaoMunicipal} onChange={e => setClinicaInscricaoMunicipal(e.target.value)} disabled={!editandoClinica} sx={fieldSx} helperText="Ex: 79299482" />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField fullWidth size="small" label="Código do Serviço (NFS-e)" value={clinicaCodigoServico} onChange={e => setClinicaCodigoServico(e.target.value)} disabled={!editandoClinica} sx={fieldSx} helperText="Ex: 04693 (Odontologia SP)" />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField fullWidth size="small" label="Descrição Padrão da Nota Fiscal" value={clinicaDescricaoPadraoNota} onChange={e => setClinicaDescricaoPadraoNota(e.target.value)} disabled={!editandoClinica} sx={fieldSx} multiline rows={2} helperText="Texto que aparecerá automaticamente na discriminação da NFS-e" />
                  </Grid>
                </Grid>
              )}
              {editandoClinica && (
                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                  <Button variant="contained" startIcon={<SaveIcon />} onClick={handleSalvarClinica} disabled={loading}
                    sx={{ bgcolor: '#F97316', '&:hover': { bgcolor: '#EA580C' }, boxShadow: '0 2px 10px rgba(249,115,22,0.35)', borderRadius: '8px', fontWeight: 700 }}>
                    Salvar Clínica
                  </Button>
                </Box>
              )}
            </TabPanel>

            {/* ABA SEGURANÇA */}
            <TabPanel value={tab} index={2}>
              <Typography variant="subtitle1" fontWeight={700} sx={{ color: '#F97316', mb: 2.5 }}>Alterar Senha</Typography>
              <Grid container spacing={2.5} sx={{ maxWidth: 480 }}>
                <Grid item xs={12}>
                  <TextField fullWidth size="small" label="Nova Senha" type={showSenha ? 'text' : 'password'} value={novaSenha} onChange={e => setNovaSenha(e.target.value)}
                    InputProps={{ endAdornment: <InputAdornment position="end"><IconButton onClick={() => setShowSenha(!showSenha)} size="small">{showSenha ? <VisibilityOffIcon /> : <VisibilityIcon />}</IconButton></InputAdornment> }}
                    sx={fieldSx} helperText="Mínimo 6 caracteres" />
                </Grid>
                <Grid item xs={12}>
                  <TextField fullWidth size="small" label="Confirmar Nova Senha" type={showSenha ? 'text' : 'password'} value={confirmarSenha} onChange={e => setConfirmarSenha(e.target.value)}
                    error={confirmarSenha !== '' && novaSenha !== confirmarSenha}
                    helperText={confirmarSenha !== '' && novaSenha !== confirmarSenha ? 'As senhas não conferem' : ''}
                    sx={fieldSx} />
                </Grid>
              </Grid>

              <Box sx={{ mt: 2, p: 2, borderRadius: '10px', bgcolor: 'rgba(249,115,22,0.06)', border: '1px solid rgba(249,115,22,0.15)', maxWidth: 480 }}>
                <Typography variant="caption" color="text.secondary">
                  💡 Dicas para uma senha segura: mínimo 8 caracteres, misture letras maiúsculas, minúsculas, números e símbolos.
                </Typography>
              </Box>

              <Box sx={{ mt: 3 }}>
                <Button variant="contained" startIcon={<LockIcon />} onClick={handleAlterarSenha} disabled={loading || !novaSenha || novaSenha !== confirmarSenha}
                  sx={{ bgcolor: '#F97316', '&:hover': { bgcolor: '#EA580C' }, boxShadow: '0 2px 10px rgba(249,115,22,0.35)', borderRadius: '8px', fontWeight: 700, '&.Mui-disabled': { bgcolor: 'action.disabledBackground' } }}>
                  Alterar Senha
                </Button>
              </Box>
            </TabPanel>

            {/* ABA CONECTAR AO CLAUDE */}
            <TabPanel value={tab} index={3}>
              <ConexaoClaude />
            </TabPanel>

          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}

export default PerfilDentistaPage;
